"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import { useMatch } from "fansunited-data-layer/client";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { MatchLineupFieldDesktop } from "./MatchLineupFieldDesktop";
import { MatchLineupFieldMobile } from "./MatchLineupFieldMobile";
import { type PlayerEvents, computePlayerEvents } from "./playerEventsHelper";
interface MatchLineupFieldProps {
  homeTeamName: string;
  awayTeamName: string;
  homeTeamCode?: string;
  awayTeamCode?: string;
  homeTeamLogo?: string;
  awayTeamLogo?: string;
  homeTeamColor?: string;
  awayTeamColor?: string;
  homeTeamCountryCode?: string;
  homeTeamCountryFlag?: string;
  homeTeamPrimaryColor?: string;
  homeTeamSecondaryColor?: string;
  awayTeamCountryCode?: string;
  awayTeamCountryFlag?: string;
  awayTeamPrimaryColor?: string;
  awayTeamSecondaryColor?: string;
  /** For mobile controlled mode - which team is currently active */
  activeTeam?: "home" | "away";
}

/**
 * MatchLineupField - Wrapper that shows desktop or mobile version based on screen size
 * Desktop: Horizontal full pitch with both teams
 * Mobile: Vertical half-pitch (controlled by parent via activeTeam prop)
 */
export const MatchLineupField: React.FC<MatchLineupFieldProps> = t0 => {
  const $ = _c(38);
  const {
    homeTeamName,
    awayTeamName,
    homeTeamCode,
    awayTeamCode,
    homeTeamLogo,
    awayTeamLogo,
    homeTeamColor: t1,
    awayTeamColor: t2,
    homeTeamCountryCode,
    homeTeamCountryFlag,
    homeTeamPrimaryColor,
    homeTeamSecondaryColor,
    awayTeamCountryCode,
    awayTeamCountryFlag,
    awayTeamPrimaryColor,
    awayTeamSecondaryColor,
    activeTeam: t3
  } = t0;
  const homeTeamColor = t1 === undefined ? "#111111" : t1;
  const awayTeamColor = t2 === undefined ? "#444444" : t2;
  const activeTeam = t3 === undefined ? "home" : t3;
  const {
    lineups,
    events
  } = useMatch();
  let t4;
  if ($[0] !== events) {
    t4 = events || [];
    $[0] = events;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== t4) {
    t5 = computePlayerEvents(t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const playerEventsMap = t5;
  if (!lineups || !lineups.confirmed) {
    return null;
  }
  const homeLineup = lineups.competitorOne;
  const awayLineup = lineups.competitorTwo;
  let t6;
  if ($[4] !== homeLineup.starters) {
    t6 = homeLineup.starters.some(_temp);
    $[4] = homeLineup.starters;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const homeHasPositions = t6;
  let t7;
  if ($[6] !== awayLineup.starters) {
    t7 = awayLineup.starters.some(_temp2);
    $[6] = awayLineup.starters;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const awayHasPositions = t7;
  if (!homeHasPositions && !awayHasPositions) {
    return null;
  }
  let t8;
  if ($[8] !== activeTeam || $[9] !== awayHasPositions || $[10] !== awayLineup || $[11] !== awayTeamCode || $[12] !== awayTeamColor || $[13] !== awayTeamCountryCode || $[14] !== awayTeamCountryFlag || $[15] !== awayTeamLogo || $[16] !== awayTeamName || $[17] !== awayTeamPrimaryColor || $[18] !== awayTeamSecondaryColor || $[19] !== homeHasPositions || $[20] !== homeLineup || $[21] !== homeTeamCode || $[22] !== homeTeamColor || $[23] !== homeTeamCountryCode || $[24] !== homeTeamCountryFlag || $[25] !== homeTeamLogo || $[26] !== homeTeamName || $[27] !== homeTeamPrimaryColor || $[28] !== homeTeamSecondaryColor || $[29] !== playerEventsMap) {
    t8 = {
      homeTeamName,
      awayTeamName,
      homeTeamCode,
      awayTeamCode,
      homeTeamLogo,
      awayTeamLogo,
      homeTeamColor,
      awayTeamColor,
      homeTeamCountryCode,
      homeTeamCountryFlag,
      homeTeamPrimaryColor,
      homeTeamSecondaryColor,
      awayTeamCountryCode,
      awayTeamCountryFlag,
      awayTeamPrimaryColor,
      awayTeamSecondaryColor,
      homeLineup,
      awayLineup,
      homeHasPositions,
      awayHasPositions,
      activeTeam,
      playerEventsMap
    };
    $[8] = activeTeam;
    $[9] = awayHasPositions;
    $[10] = awayLineup;
    $[11] = awayTeamCode;
    $[12] = awayTeamColor;
    $[13] = awayTeamCountryCode;
    $[14] = awayTeamCountryFlag;
    $[15] = awayTeamLogo;
    $[16] = awayTeamName;
    $[17] = awayTeamPrimaryColor;
    $[18] = awayTeamSecondaryColor;
    $[19] = homeHasPositions;
    $[20] = homeLineup;
    $[21] = homeTeamCode;
    $[22] = homeTeamColor;
    $[23] = homeTeamCountryCode;
    $[24] = homeTeamCountryFlag;
    $[25] = homeTeamLogo;
    $[26] = homeTeamName;
    $[27] = homeTeamPrimaryColor;
    $[28] = homeTeamSecondaryColor;
    $[29] = playerEventsMap;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  const sharedProps = t8;
  let t9;
  if ($[31] !== sharedProps) {
    t9 = <div className="hidden md:block"><MatchLineupFieldDesktop {...sharedProps} /></div>;
    $[31] = sharedProps;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== sharedProps) {
    t10 = <div className="block md:hidden"><MatchLineupFieldMobile {...sharedProps} /></div>;
    $[33] = sharedProps;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t10 || $[36] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[35] = t10;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  return t11;
};
function _temp(p) {
  return p.positionX && p.positionY;
}
function _temp2(p_0) {
  return p_0.positionX && p_0.positionY;
}